import { ItfNewsTag } from './type';

export const INIT_NEWS_TAG: ItfNewsTag = 'website-news';
export const ECOFLOW_LOGO: string = 'https://websiteoss.ecoflow.com/upload/image/1735782674645/logo.svg';
